"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SecToMsMultiplier = 1000;
var AWTKillSwitch = /** @class */ (function () {
    function AWTKillSwitch() {
        this._killedTokenDictionary = {};
    }
    AWTKillSwitch.prototype.setKillSwitchTenants = function (killTokens, killDuration) {
        var _this = this;
        if (killTokens && killDuration) {
            try {
                var killedTokens = killTokens.split(',');
                if (killDuration === 'this-request-only') {
                    return killedTokens;
                }
                var durationMs_1 = parseInt(killDuration, 10) * SecToMsMultiplier;
                killedTokens.forEach(function (token) {
                    _this._killedTokenDictionary[token] = Date.now() + durationMs_1;
                });
            }
            catch (ex) {
                return [];
            }
        }
        return [];
    };
    AWTKillSwitch.prototype.isTenantKilled = function (tenantToken) {
        if (this._killedTokenDictionary[tenantToken] !== undefined && this._killedTokenDictionary[tenantToken] > Date.now()) {
            return true;
        }
        delete this._killedTokenDictionary[tenantToken];
        return false;
    };
    return AWTKillSwitch;
}());
exports.default = AWTKillSwitch;
